import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import Url from '../../apiBaseUrl/APIConfig';
import type { LoginResponse, TokenAuthBody } from './Model';
import { setupInterceptorsTo } from '../authenticationInterceptors/Interceptors';

type InitialState = {
  loading: boolean;
  response: LoginResponse;
  successMsg: string;
  error: string;
};

const initialState: InitialState = {
  loading: false,
  response: {} as LoginResponse,
  successMsg: '',
  error: '',
};

// Headers for URL-encoded form data
const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/x-www-form-urlencoded',
};

export const erpnextLogin = createAsyncThunk<LoginResponse, TokenAuthBody>(
  'erpnextLogin/erpnextLogin',
  async (payload: TokenAuthBody, { rejectWithValue }) => {
    const params = new URLSearchParams();
    params.append('client_id', 'erpnext');
    params.append('username', payload.username);
    params.append('password', payload.password);
    params.append('grant_type', 'password');
    params.append('client_secret', 'sadafasufalknfjaafnjafada');

    localStorage.setItem('username', payload.username);

    return await setupInterceptorsTo(axios)
      .post(Url.baseUrl + '/realms/ssssh/protocol/openid-connect/token', params.toString(), { headers })
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue(
          error?.response?.data !== undefined
            ? error.response.data.message !== undefined
              ? error.response.data.message
              : 'Something went wrong'
            : 'Something went wrong'
        )
      );
  }
);

const erpnextLoginSlice = createSlice({
  name: 'erpnextLogin',
  initialState,
  reducers: {
    updateErpnextLoginClearMsg: (state) => {
      state.successMsg = '';
      state.error = '';
    },
    updateErpnextLoginClearRes: (state) => {
      state.successMsg = '';
      state.error = '';
      state.response = {} as LoginResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(erpnextLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      erpnextLogin.fulfilled,
      (state, action: PayloadAction<LoginResponse>) => {
        state.loading = false;
        state.response = action.payload;
        state.successMsg = 'Login Successful';
        localStorage.setItem('access', action.payload.access_token);
        localStorage.setItem('refresh', action.payload.refresh_token);
      }
    );
    builder.addCase(erpnextLogin.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as LoginResponse;
      state.successMsg = '';
      state.error = String(action.payload) || 'Something went wrong';
    });
  },
});

export const { updateErpnextLoginClearMsg, updateErpnextLoginClearRes } =
  erpnextLoginSlice.actions;
export default erpnextLoginSlice.reducer;